import IdentifiableDto from 'modules/base/dto/IdentifiableDto';
import VizsgaHelyeDto from './VizsgaHelyeDto';

export class VizsgazoInputFormDataDto extends IdentifiableDto {
	constructor() {
		super();
		/** @type {number[]} */
		this.csoport = null;
		/** @type {VizsgaHelyeDto[]} */
		this.vizsga_helye = null;
	}

	/**
	 * @typedef {Object} _VizsgazoInputFormDataDtoProps
	 * @property {number[]} csoport
	 * @property {VizsgaHelyeDto[]} vizsga_helye
	 *
	 * @typedef {import("modules/base/dto/IdentifiableDto").IdentifiableDtoProps & _VizsgazoInputFormDataDtoProps} VizsgazoInputFormDataDtoProps
	 */
	/**
	 *
	 * @param {VizsgazoInputFormDataDtoProps} props
	 * @returns {VizsgazoInputFormDataDto}
	 */
	setup(props) {
		super.setup(props);
		this.csoport = props.csoport;
		this.vizsga_helye = props.vizsga_helye !== null ? props.vizsga_helye.map(d => new VizsgaHelyeDto().setup(d)) : null;
		return this;
	}
}

export default VizsgazoInputFormDataDto;
